import { Star } from "lucide-react";

export default function StarRating({ value = 0, count, size = 14, showCount = true }) {
  const v = Math.round((value || 0) * 2) / 2;
  return (
    <div className="inline-flex items-center gap-1">
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star
            key={i}
            style={{ width: size, height: size }}
            className={i <= v ? "fill-amber-400 text-amber-400" : "fill-stone-200 text-stone-300"}
          />
        ))}
      </div>
      <span className="text-xs text-muted-foreground font-medium">
        {value ? value.toFixed(1) : "—"}
        {showCount && count !== undefined ? ` (${count})` : ""}
      </span>
    </div>
  );
}
